// Single source of truth for the mobile layout breakpoint and the small
// cross-component events used by the mobile layout.
// Keep MOBILE_MAX_WIDTH_PX in sync with $mobile-breakpoint-max (991.98px)
// in assets/scss/_mobile.scss.

export const MOBILE_MAX_WIDTH_PX = 991;

// Fired by the mobile footer bar ("More") and handled by the Header, which owns
// the menu. detail.open (boolean) forces a state; without it the menu toggles.
export const HEADER_MENU_EVENT = 'focus:header-menu';

export const isMobileViewport = () => window.innerWidth <= MOBILE_MAX_WIDTH_PX;

export const setHeaderMenuOpen = open =>
  window.dispatchEvent(
    new CustomEvent(HEADER_MENU_EVENT, {
      detail: typeof open === 'boolean' ? { open } : {}
    })
  );
